<!--
  A given selector (e.g. "[title-extra]") may only be claimed by ONE <ng-content>
  in this template: Angular assigns each projected node to the FIRST matching
  <ng-content> found in template order, independent of which @if/@else branch
  actually renders. Two <ng-content select="[title-extra]"> below (one per
  branch) would silently drop the content whenever the *other* branch is the
  one that renders. So each selector gets a single <ng-content>, captured once
  here and replayed into whichever branch is active via ngTemplateOutlet.
-->
<ng-template #titleExtraContent>
  <ng-content select="[title-extra]"></ng-content>
</ng-template>
<ng-template #navActionContent>
  <ng-content select="[nav-action]"></ng-content>
</ng-template>
<!-- Optional leading element in the title row (e.g. a phone back arrow). It sets its own order. -->
<ng-template #titlePrefixContent>
  <ng-content select="[title-prefix]"></ng-content>
</ng-template>

<!-- The title row has no side padding: user-layout's <main> is the one 16px gutter, so the title
     lines up with the page content (#6171). -->
<div class="tw-flex tw-w-full tw-h-full tw-flex-col">
  @if (navActionInlineOnMobile) {
    <div class="tw-flex tw-flex-wrap tw-items-center tw-gap-3 tw-py-4">
      <ng-container *ngTemplateOutlet="titlePrefixContent"></ng-container>
      <span
        class="page-wrapper-title tw-order-1 tw-text-2xl tw-font-medium tw-text-dt-text-headings xs:tw-text-center tw-whitespace-nowrap"
      >
        {{ title }}
      </span>
      <div
        class="tw-order-2 sm:tw-order-3 tw-flex tw-items-center tw-flex-wrap tw-gap-3 sm:tw-w-full"
      >
        <ng-container *ngTemplateOutlet="titleExtraContent"></ng-container>
      </div>
      <div class="tw-order-3 sm:tw-order-2 tw-ml-auto tw-flex tw-shrink-0 tw-items-center tw-gap-2">
        <ng-container *ngTemplateOutlet="navActionContent"></ng-container>
      </div>
    </div>
  } @else {
    <div
      class="tw-flex tw-justify-between tw-items-center tw-gap-3 tw-py-4 sm:tw-flex-col sm:tw-gap-2"
    >
      <div class="page-wrapper-title-row tw-flex tw-items-center tw-flex-wrap tw-gap-3">
        <ng-container *ngTemplateOutlet="titlePrefixContent"></ng-container>
        <span
          class="page-wrapper-title tw-text-2xl tw-font-medium tw-text-dt-text-headings xs:tw-text-center tw-whitespace-nowrap"
        >
          {{ title }}
        </span>
        <ng-container *ngTemplateOutlet="titleExtraContent"></ng-container>
      </div>
      <div class="tw-flex tw-shrink-0 tw-justify-end tw-items-center tw-gap-2 sm:tw-w-full">
        <ng-container *ngTemplateOutlet="navActionContent"></ng-container>
      </div>
    </div>
  }
  <div class="tw-flex tw-justify-between tw-w-full tw-h-full tw-gap-2">
    <ng-content></ng-content>
  </div>
</div>
